export default "__VITE_ASSET__syf9H6hv__"